import React from 'react';
import { HiCheckCircle, HiClock, HiXCircle } from 'react-icons/hi2';

const STATUS_OPTIONS = ['Not started', 'In progress', 'Blocked', 'Done'];

export default function GTMTaskTracker({ tasks, setTasks, onChange, readOnly = false }) {
  const handleStatusChange = (id, status) => {
    if (readOnly) return;
    const next = tasks.map(t => (t.id === id ? { ...t, status } : t));
    setTasks(next);
    onChange?.(next);
  };

  const handleTitleChange = (id, title) => {
    if (readOnly) return;
    const next = tasks.map(t => (t.id === id ? { ...t, title } : t));
    setTasks(next);
    onChange?.(next);
  };

  const handleDueChange = (id, dueDate) => {
    if (readOnly) return;
    const next = tasks.map(t => (t.id === id ? { ...t, dueDate } : t));
    setTasks(next);
    onChange?.(next);
  };

  const addTask = () => {
    if (readOnly) return;
    setTasks([
      ...(tasks || []),
      { id: crypto.randomUUID(), title: '', status: 'Not started', dueDate: '' },
    ]);
  };

  const removeTask = id => {
    if (readOnly) return;
    setTasks((tasks || []).filter(t => t.id !== id));
  };

  return (
    <div className="rounded-xl border border-gray-200 bg-white p-6 shadow-sm">
      <div className="mb-4 flex items-center gap-2">
        <HiClock className="h-5 w-5 text-blue-600" />
        <h3 className="text-lg font-semibold text-gray-900">GTM Task Tracker</h3>
      </div>
      <div className="space-y-3">
        {(tasks || []).map(task => (
          <div
            key={task.id}
            className="grid grid-cols-1 gap-3 rounded-lg border border-gray-200 p-3 sm:grid-cols-12"
          >
            <input
              className="rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500 sm:col-span-6"
              placeholder="Task title"
              value={task.title}
              onChange={e => handleTitleChange(task.id, e.target.value)}
              disabled={readOnly}
            />
            <input
              type="date"
              className="rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500 sm:col-span-3"
              value={task.dueDate || ''}
              onChange={e => handleDueChange(task.id, e.target.value)}
              disabled={readOnly}
            />
            <select
              className="rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500 sm:col-span-2"
              value={task.status}
              onChange={e => handleStatusChange(task.id, e.target.value)}
              disabled={readOnly}
            >
              {STATUS_OPTIONS.map(s => (
                <option key={s} value={s}>
                  {s}
                </option>
              ))}
            </select>
            <button
              onClick={() => removeTask(task.id)}
              className="rounded-md border border-gray-300 px-3 py-2 text-sm text-gray-700 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-60 sm:col-span-1"
              disabled={readOnly}
            >
              <HiXCircle className="h-5 w-5" />
            </button>
          </div>
        ))}
      </div>
      <div className="mt-4 flex items-center justify-between">
        <button
          onClick={addTask}
          disabled={readOnly}
          className="rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700 disabled:cursor-not-allowed disabled:bg-blue-300"
        >
          Add Task
        </button>
        <div className="flex items-center gap-2 text-xs text-gray-600">
          <HiCheckCircle className="h-4 w-4 text-green-600" />
          <span>Track completion per task</span>
        </div>
      </div>
    </div>
  );
}
